export default "__VITE_ASSET__CrT25wMf__"